module.exports = __webpack_public_path__ + "static/media/8OLA31.547af41e.jpg";